
<template>
  <PrimeDataTable
    :value="value"
    :paginator="paginator"
    :rows="rows"
    :total-records="totalRecords"
    :loading="loading"
    :selection="selection"
    :row-key="rowKey"
    scrollable
    :scroll-height="scrollHeight"
    data-testid="data-table"
    v-bind="$attrs"
    @update:selection="onSelectionUpdate"
  >
    <slot />
    <template
      v-if="$slots.empty"
      #empty
    >
      <slot name="empty" />
    </template>
  </PrimeDataTable>
</template>

<script setup lang="ts">
import PrimeDataTable from 'primevue/datatable';

const props = defineProps({
  value: { type: Array, required: true },
  paginator: { type: Boolean, default: false },
  rows: { type: Number, default: 10 },
  totalRecords: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
  selection: { type: [Array, Object], default: null },
  rowKey: { type: String, default: undefined },
  scrollHeight: { type: String, default: '100%' },
});

const emit = defineEmits(['update:selection']);

function onSelectionUpdate(val: any) {
  emit('update:selection', val);
}
</script>
